<template>
  <div :class="this.$route.name" v-if="cases.length">

    <section class="hero-cases">
      <div class="wrap">
        <div class="hero-cases-wrap">
          <div class="hero-cases-media">
            <element-media
              ref="player"
              :key="featured.uriname"
              class="medianowrap"
              :src="featured.video"
              :thumbnail="featured.thumbnail" />
          </div>
          <div class="hero-cases-content" ref="heroContent">
            <div class="title">{{ featured.city }}</div>
            <div class="body">{{ featured.body }}</div>
            <router-link :to="{name: 'Home'}" class="button filled">Læs mere om De Små Ting</router-link>
          </div>
        </div>
      </div>
    </section>

    <section class="case-videos">
      <div class="wrap">
        <div class="case-videos-wrap">

          <case-video @click.native="play(index)" :key="item.uriname" v-for="(item, index) in cases"
            :title="item.title"
            :subtitle="item.city"
            :src="item.thumbnail + '?width=400'"
          />

        </div>
      </div>
    </section>

    <section-contact />
  </div>
</template>

<script>

import sectionContact from '@sections/contact'
import SectionResolver from '@/library/section-resolver'

import elementMedia from '@elements/media'
import caseVideo from '@elements/case-video'

import CasesModel from '@/models/cases'
import {TimelineLite, TweenLite, Power0} from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

import { random } from 'lodash'

/* eslint-disable-next-line */
const modules = [ ScrollToPlugin ]

export default {
  inject: ['$config'],
  components: { SectionResolver, sectionContact, elementMedia, caseVideo },
  data: () => ({
    cases: [],
    active: 0
  }),
  async beforeRouteEnter (to, from, next) {
    let cases = await CasesModel.all()

    next(vm => {
      const active = window.location.hash.length > 1 ? cases.map(item => item.uriname).indexOf(window.location.hash.slice(1)) : random(0, cases.length - 1, false)
      console.log(active)
      vm.$set(vm.$data, 'active', active)
      vm.$set(vm.$data, 'cases', cases)
    })
  },
  computed: {
    featured () {
      return this.cases[this.active]
    }
  },
  methods: {
    play (index) {
      const tl = new TimelineLite({
        onComplete: () => {
          this.active = index
          history.replaceState({key: this.featured.uriname}, document.title, `${window.location.pathname}#${this.featured.uriname}`)

          TweenLite.to(this.$refs.heroContent.children, 0.15, {
            delay: 0,
            opacity: 1,
            onComplete: () => this.$refs.player.play()
          }, 0.05)
        }
      })

      tl.to(window, 0.25, { ease: Power0.easeOut, scrollTo: { y: 0, autoKill: false }, reverse: false })

      if (this.active !== index) {
        tl.to(this.$refs.heroContent.children, 0.1, { opacity: 0 }, 0.025)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';

.hero-cases {
  margin-top: calc(#{$global-padding} * 2);
  margin-bottom: calc(#{$global-padding} * 6);

  @media #{$below-breakpoint-1024} {
    margin-bottom: calc(#{$global-padding} * 4);
  }
}

.hero-cases-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;

  @media #{$below-breakpoint-1024} {
    flex-direction: column;
    align-items: flex-start;
  }
}

.hero-cases-media {
  width: 100%;

  position: relative;
  z-index: 10;

  @media #{$above-breakpoint-1024} {
    flex: 1 1 1%;
    max-width: 700px;
  }

  @media #{$below-breakpoint-1024} {
    max-width: 100%;
    margin-bottom: calc(#{$global-padding} * 3);
  }

  .media {
    max-width: 100%;
    margin-bottom: 0;
  }
}

.hero-cases-content {
  max-width: 100%;

  @media #{$above-breakpoint-1024} {
    flex: 0 0 340px;
    margin: calc(#{$global-padding} * 3);
  }

  @media #{$below-breakpoint-1024} {
    margin-left: 0;
    width: 100%;
    flex: 1 1 auto;
    max-width: 640px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .title {
    @include font-size(24px, 30px);
    font-weight: 700;
  }

  .body {
    @include font-size(14px, 16px);
    line-height: 1.5;
    font-weight: 700;

    margin: calc(#{$global-padding} * 1) 0 calc(#{$global-padding} * 2);

    &:before {
      content: "";
      display: block;
      margin-bottom: calc(#{$global-padding} * 1);
      background: #e4003f;
      height: 10px;
      width: 74px;
    }
  }
}

.case-videos-wrap {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  margin: -20px;

  @media #{$above-breakpoint-1024} {
    flex-direction: row;
  }

  @media only screen and (min-device-width : 768px)  and (max-device-width : 1024px)  {
    flex-direction: row;
  }
}
</style>

<style lang="scss">
.medianowrap .wrap {
  padding: 0;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/Cases.vue